"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputAxisFromKeys = void 0;
const KHInputAxisDerived_1 = require("./KHInputAxisDerived");
/**
 * An axis that translates two keys into positive and negative inputs for an
 * axis, adding 1 for a pressed positive key, and subtracting 1 for a pressed
 * negative key.
 */
class KHInputAxisFromKeys extends KHInputAxisDerived_1.KHInputAxisDerived {
    constructor(inputSet, positiveKey, negativeKey = null) {
        super(inputSet);
        this.positiveKey = positiveKey;
        this.negativeKey = negativeKey;
    }
    updateDerivedInput(now, delta) {
        var _a, _b;
        this.update((((_a = this.positiveKey) === null || _a === void 0 ? void 0 : _a.isDown()) ? 1 : 0)
            + (((_b = this.negativeKey) === null || _b === void 0 ? void 0 : _b.isDown()) ? -1 : 0));
    }
}
exports.KHInputAxisFromKeys = KHInputAxisFromKeys;
